// #region Composables
import { useUsersStore } from '~/entities/user/user/stores/users'

import { useTenantStore } from '~/features-shared/config-manager/stores/tenant'

import { useFeatureManager } from '~/features-generic/config-manager/composables/feature-manager'

// #endregion Composables

// #region Stores

// #endregion Stores

/**
 * Composable for community creation
 * Currently provides a way to determine if the icon for community creation should be seen by the user or not.
 */
export function useCommunityCreation() {
  const tenantStore = useTenantStore()
  const userStore = useUsersStore()
  const isCommunityCreationActivated = useFeatureManager('community.creation')

  const shouldShowCreateCommunityIcon = computed(() => {
    if (!isCommunityCreationActivated.value)
      return false
      // Tenant config
    const {
      plan_a_community: canPlanCommunity,
      allow_add_community_for_everyone: allowAddCommunityForEveryone,
    } = tenantStore.tenantOptions?.config?.tenant ?? {
      plan_a_community: false,
      allow_add_community_for_everyone: false,
    }

    // Current user config
    const currenUser = userStore.currentUser
    const isUserTenantAdmin = currenUser?.tenant_admin === '1'
    const isUserAllowedToCreateCommunity = !!currenUser?.canCreateCommunity

    return isUserTenantAdmin
      || isUserAllowedToCreateCommunity
      || canPlanCommunity
      || allowAddCommunityForEveryone
  })

  return {
    /** Should the icon for community creation be shown to current user. */
    shouldShowCreateCommunityIcon,
  }
}
